import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import {
  GET_TABELAS_RELATORIOS_INIT,
  POST_EXECUTA_CONSULTA_RELATORIO_INIT,
  CREATE_RELATORIO_INIT,
  UPDATE_RELATORIO_INIT,
  DELETE_RELATORIO_INIT
} from '../actionTypes';
import { obtemTabelasRelatorioSuccess, construtorErroMsg, executaConsultaRelatorioSuccess, construtorConsultaNaoEncontrada, criarRelatorioSuccess, editarRelatorioSuccess, excluiRelatorioSuccess } from '../actions';
import { FarmaError } from 'src/integracoes/modelos/erros';
import { criarRelatorioPersonalizado, editarRelatorioPersonalizado, excluiRelatorioPersonalizado, executarConsultaRelatorio, obtemTabelasRelatorio } from 'src/integracoes/servicos/aws/funcoes/construtoRelatorio';
import { IQueryRelatorio, IRelatorio } from 'src/integracoes/servicos/aws/modelos/IConstrutor';

/* ------------------Obtem Relatorios---------------- */
export const fetchObtemRelatorios = async (): Promise<any> => {
  try {
    const { status, dados, mensagem } = await obtemTabelasRelatorio();
    if (status) {
      return {
        isSuccess: status,
        relatoriosCadastrados: dados,
        msg: mensagem,
      };
    } else {
      return {
        isSuccess: status,
        msg: mensagem,
        relatoriosCadastrados: []
      };
    }
  } catch (error: any) {
    throw new FarmaError(error);
  }
};

function* parseObtemRelatorios() {
  try {
    const { isSuccess, relatoriosCadastrados, msg } = yield call(fetchObtemRelatorios);
    if (isSuccess) {
      yield put(obtemTabelasRelatorioSuccess({ relatoriosCadastrados }));
    } else {
      yield put(construtorErroMsg({ msg }));
    }
  } catch (error: any) {
    const mensagem = error.mensagem ? `${error.mensagem}` : `${error.message}`;
    yield put(construtorErroMsg({ msg: mensagem }));
  }
}

export function* watchObtemRelatorios() {
  yield takeEvery(GET_TABELAS_RELATORIOS_INIT, parseObtemRelatorios);
}

/* ------------------Executa consulta relatorio ---------------- */
export const fetchExecutaConcultaRelatorio = async (relatorio: IQueryRelatorio, valor: number) => {
  try {
    const { status, dados, mensagem } = await executarConsultaRelatorio(relatorio, valor);
    if (status) {
      return {
        isSuccess: status,
        dadosConsulta: dados,
        msg: mensagem
      };
    } else {
      return {
        isSuccess: status,
        msg: mensagem,
        dadosConsulta: []
      };
    }
  } catch (error: any) {
    throw new FarmaError(error);
  }
};

function* parseExecutaConcultaRelatorio({ payload }: { payload: any; type: any }) {
  const { relatorio, valor } = payload;
  try {
    const { msg, dadosConsulta, isSuccess } = yield call(fetchExecutaConcultaRelatorio, relatorio, valor);

    if (Array.isArray(dadosConsulta) && dadosConsulta.length === 0) {
      yield put(construtorConsultaNaoEncontrada({ msg }));
    }

    if (isSuccess) {
      yield put(executaConsultaRelatorioSuccess({ dadosConsulta }));
    } else {
      yield put(construtorErroMsg({ msg }));
    }
  } catch (error: any) {
    const mensagem = error.mensagem ? `${error.mensagem}` : `${error.message}`;
    yield put(construtorErroMsg({ msg: mensagem }));
  }
}

export function* watchExecutaConsultaRelatorio() {
  yield takeEvery(POST_EXECUTA_CONSULTA_RELATORIO_INIT, parseExecutaConcultaRelatorio);
}

/* ------------------Criar relatorio personalizado---------------- */
export const fetchCriarRelatorio = async (relatorio: IRelatorio) => {
  try {
    const { status, dados, mensagem } = await criarRelatorioPersonalizado(relatorio);
    if (status) {
      return {
        isCreated: status,
        relatorio: dados,
        msg: mensagem
      };
    } else {
      return {
        isCreated: status,
        msg: mensagem,
        relatorio: {}
      };
    }
  } catch (error: any) {
    throw new FarmaError(error);
  }
};

function* parseCriarRelatorio({ payload }: { payload: any; type: any }) {
  const { NovoRelatorio } = payload;
  try {
    const { msg, relatorio, isCreated } = yield call(fetchCriarRelatorio, NovoRelatorio);

    if (isCreated) {
      yield put(criarRelatorioSuccess({ novoRelatorio: relatorio, msg }));
    } else {
      yield put(construtorErroMsg({ msg }));
    }
  } catch (error: any) {
    const mensagem = error.mensagem ? `${error.mensagem}` : `${error.message}`;
    yield put(construtorErroMsg({ msg: mensagem }));
  }
}

export function* watchCriarRelatorio() {
  yield takeEvery(CREATE_RELATORIO_INIT, parseCriarRelatorio);
}

/* ------------------Editar relatorio personalizado---------------- */
export const fetchEditarRelatorio = async (id: string, relatorio: IRelatorio) => {
  try {
    const { status, dados, mensagem } = await editarRelatorioPersonalizado(id, relatorio);
    if (status) {
      return {
        isUpdated: status,
        relatorioAtualizado: dados,
        msg: mensagem
      };
    } else {
      return {
        isUpdated: status,
        msg: mensagem,
        relatorioAtualizado: {}
      };
    }
  } catch (error: any) {
    throw new FarmaError(error);
  }
};

function* parseEditarRelatorio({ payload }: { payload: any; type: any }) {
  const { id, relatorio } = payload;

  try {
    const { msg, isUpdated, relatorioAtualizado } = yield call(fetchEditarRelatorio, id, relatorio);

    if (isUpdated) {
      yield put(editarRelatorioSuccess({ msg, relatorioAtualizado }));
    } else {
      yield put(construtorErroMsg({ msg }));
    }
  } catch (error: any) {
    const mensagem = error.mensagem ? `${error.mensagem}` : `${error.message}`;
    yield put(construtorErroMsg({ msg: mensagem }));
  }
}

export function* watchEditarRelatorio() {
  yield takeEvery(UPDATE_RELATORIO_INIT, parseEditarRelatorio);
}

/* ------------------Exclui relatorio personalizado---------------- */
export const fetchExcluiRelatorio = async (id: string) => {
  try {
    const { status, dados, mensagem } = await excluiRelatorioPersonalizado(id);

    if (status) {
      return {
        isDeleted: status,
        idRelatorio: dados.id,
        msg: mensagem
      };
    } else {
      return {
        isDeleted: status,
        msg: mensagem,
        idRelatorio: ''
      };
    }
  } catch (error: any) {
    throw new FarmaError(error);
  }
};

function* parseExcluiRelatorio({ payload }: { payload: any; type: any }) {
  const { id } = payload;
  try {
    const { msg, idRelatorio, isDeleted } = yield call(fetchExcluiRelatorio, id);

    if (isDeleted) {
      yield put(excluiRelatorioSuccess({ idRelatorio, msg }));
    } else {
      yield put(construtorErroMsg({ msg }));
    }
  } catch (error: any) {
    const mensagem = error.mensagem ? `${error.mensagem}` : `${error.message}`;
    yield put(construtorErroMsg({ msg: mensagem }));
  }
}

export function* watchExcluiRelatorio() {
  yield takeEvery(DELETE_RELATORIO_INIT, parseExcluiRelatorio);
}

// WATCHS
export default function* rootSaga() {
  yield all([
    fork(watchObtemRelatorios),
    fork(watchExecutaConsultaRelatorio),
    fork(watchCriarRelatorio),
    fork(watchEditarRelatorio),
    fork(watchExcluiRelatorio),
  ]);
}
